import {ChangeDetectorRef, Component, Inject, ViewChild, ViewContainerRef} from '@angular/core';
import {DetailPopup} from '../../../mapping-classes/detail-popup';
import * as DetailTable from '../../../table-lib';
import {DomService} from "../../../../../../services/dom-service/dom.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MandatesTableComponent} from "../../../detail-table/mandates/mandates-table.component";

@Component({
  selector: 'app-detail-table',
  templateUrl: './mandates.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class MandatesComponent implements DetailPopup {

  @ViewChild('mandatesTable', {read: ViewContainerRef}) mandatesTableContainer: ViewContainerRef;

  errorText: string;
  restrictedData: boolean;
  title: string;
  data: any;
  hasData = true;
  tableInstance: any;
  tableComponent: any;

  constructor(private domService: DomService, private changeRef: ChangeDetectorRef,
              public dialogRef: MatDialogRef<MandatesComponent>,
              @Inject(MAT_DIALOG_DATA) public inputData: any) {
    this.title = "Machtigingen";

    if (inputData.listOfError && inputData.listOfError.length !== 0) {
      this.createErrorMessage(inputData);
      this.hasData = false;
    } else if (inputData.detailsViewObject) {
      this.data = inputData;
    }
  }

  ngAfterViewInit() {
    this.addValues(this.data);
    this.changeRef.detectChanges();
  }

  close() {
    this.dialogRef.close();
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F016') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.title = 'Machtigingen';
        this.errorText = 'Geen data gevonden.';
      }
    }
  }

  addValues(response) {
    if (!response) {
      return;
    }
    const detailsViewObject = response.detailsViewObject || {};
    if(detailsViewObject.mandates) {
      this.createMandatesTable(detailsViewObject);
    }
  }

  private createMandatesTable(detailsViewObject) {
    this.changeRef.detectChanges();
    this.tableInstance = new DetailTable['Mandates'](detailsViewObject.mandates);
    if (!this.mandatesTableContainer) {
      return null;
    }
    const viewRef = this.domService.addComponentToDOM(MandatesTableComponent, this.mandatesTableContainer);
    const tableComponentToReturn = viewRef.instance as MandatesTableComponent;
    this.tableComponent = this.setTableValues(tableComponentToReturn);
  }

  private setTableValues(componentToReturn) {
    componentToReturn.errorText = this.tableInstance.errorText;
    componentToReturn.showTable = (componentToReturn.errorText === null || componentToReturn.errorText === undefined);
    componentToReturn.restrictedData = this.restrictedData;
    componentToReturn.tableColumns = this.tableInstance.rowHeaders;
    componentToReturn.tableData = this.tableInstance.rowData;
    return componentToReturn;
  }
}
